import React from "react";
import isEmpty from "lodash/isEmpty";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectCurrentQueryResults } from "views/logic/slices/viewSelectors";
import ExecutionInfo from "views/components/views/ExecutionInfo";
const ViewsExecutionInfo = () => {
  var _a, _b;
  const result = useViewsSelector(selectCurrentQueryResults);
  if (isEmpty(result)) {
    return /* @__PURE__ */ React.createElement("i", null, "No query executed yet.");
  }
  const total = (result == null ? void 0 : result.searchTypes) && ((_b = (_a = Object.values(result == null ? void 0 : result.searchTypes)) == null ? void 0 : _a.find((e) => e.total)) == null ? void 0 : _b.total);
  return /* @__PURE__ */ React.createElement(
    ExecutionInfo,
    {
      duration: result == null ? void 0 : result.duration,
      executedAt: result == null ? void 0 : result.timestamp,
      executionFinished: !isEmpty(result),
      total
    }
  );
};
export default ViewsExecutionInfo;
